import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["task", "replacementContainer", "replaceable", "selected"]

  markSelectedAsComplete(event) {
    event.preventDefault();
    const taskIds = this.checkedTaskTargets().map(element => element.dataset.taskId);
    this.checkedTaskTargets().forEach(element => {
      if (element.dataset.completed != 'true') {
        let domId = element.dataset.domId
        document.getElementById(domId).innerHTML = this.replacementContainerTarget.innerHTML;
      }
    });
    const url = event.currentTarget.dataset.url;
    fetch(url, {
      method: 'PUT',
      headers: { 'X-CSRF-Token': this.token, 'Content-Type': 'application/json' },
      body: JSON.stringify({ "task_ids": taskIds, "completed": true })
    });
  }

  markSelectedAsIncomplete(event) {
    event.preventDefault();
    const taskIds = this.checkedTaskTargets().map(element => element.dataset.taskId);
    this.checkedTaskTargets().forEach(element => {
      if (element.dataset.completed != 'false') {
        let domId = element.dataset.domId
        document.getElementById(domId).innerHTML = this.replacementContainerTarget.innerHTML;
      }
    });
    const url = event.currentTarget.dataset.url;
    fetch(url, {
      method: 'PUT',
      headers: { 'X-CSRF-Token': this.token, 'Content-Type': 'application/json' },
      body: JSON.stringify({ "task_ids": taskIds, "completed": false })
    });
  }

  markAllAsComplete(event) {
    event.preventDefault();
    const taskIds = this.taskTargets.map(element => element.dataset.taskId);
    this.taskTargets.forEach(element => {
      if (element.dataset.completed != 'true') {
        let domId = element.dataset.domId
        document.getElementById(domId).innerHTML = this.replacementContainerTarget.innerHTML;
      }
    });
    const url = event.currentTarget.dataset.url;
    fetch(url, {
      method: 'PUT',
      headers: { 'X-CSRF-Token': this.token, 'Content-Type': 'application/json' },
      body: JSON.stringify({ "task_ids": taskIds, "completed": true })
    });
  }


  destroySelected(event) {
    event.preventDefault();
    var response = confirm(event.currentTarget.dataset.confirm)
    if (response) {
      const taskIds = this.checkedTaskTargets().map(element => element.dataset.taskId);
      this.replaceableTargets.forEach(element => {
        if (element.dataset.completed != 'false') {
          element.innerHTML = this.replacementContainerTarget.innerHTML;
        }
      });
      const url = event.currentTarget.dataset.url;
      fetch(url, {
        method: 'DELETE',
        headers: { 'X-CSRF-Token': this.token, 'Content-Type': 'application/json' },
        body: JSON.stringify({ "task_ids": taskIds })
      });
    } else {
      return
    }

  }

  // private

  checkedTaskTargets() {
    return this.taskTargets.filter(task => task.checked)
  }


  get token() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  }
}
